import axios from "axios";
import { CONST } from "../config/const";

export interface DashboardKpiRow {
  toss_up_number: number;
  toss_up_valid_appoint_number: number;
  toss_up_pre_check_ok_number: number;
  toss_up_open_number: number;
  closing_appoint_number: number;
  closing_success_number: number;
  closing_open_number: number;
  entry_number_shot: number;
  entry_number_stack: number;
  entry_shot_open_number: number;
  entry_stack_open_number: number;
  entry_cancell_number: number;
  entry_shot_cancell_number: number;
  entry_stack_cancell_number: number;
  opening_number: number | null;
  cancell_number: number | null;
}

export interface DashboardResponse {
  month_to_date: DashboardKpiRow;
  last_month: DashboardKpiRow;
  today?: DashboardKpiRow;
  yesterday?: DashboardKpiRow;
  days_elapsed: number;
  days_in_month: number;
}

const emptyRow: DashboardKpiRow = {
  toss_up_number: 0,
  toss_up_valid_appoint_number: 0,
  toss_up_pre_check_ok_number: 0,
  toss_up_open_number: 0,
  closing_appoint_number: 0,
  closing_success_number: 0,
  closing_open_number: 0,
  entry_number_shot: 0,
  entry_number_stack: 0,
  entry_shot_open_number: 0,
  entry_stack_open_number: 0,
  entry_cancell_number: 0,
  entry_shot_cancell_number: 0,
  entry_stack_cancell_number: 0,
  opening_number: 0,
  cancell_number: 0,
};

/** API未取得時用のデフォルト（カード表示用） */
export function getEmptyDashboardResponse(daysElapsed: number, daysInMonth: number): DashboardResponse {
  return {
    month_to_date: { ...emptyRow },
    last_month: { ...emptyRow, opening_number: null, cancell_number: null },
    today: { ...emptyRow },
    yesterday: { ...emptyRow },
    days_elapsed: daysElapsed,
    days_in_month: daysInMonth,
  };
}

/** 日別詳細KPI（パートナー/アカウント絞り込み対応） */
export interface DashboardDailyDetailResponse {
  date: string;
  toss_up_number: number;
  toss_up_valid_appoint_number: number;
  toss_up_pre_check_ok_number: number;
  toss_up_open_number: number;
  closing_appoint_number: number;
  closing_success_number: number;
  entry_number_shot: number;
  entry_number_stack: number;
  entry_shot_open_number: number;
  entry_stack_open_number: number;
}

export async function getDashboardDailyDetail(params: {
  date: string;
  partner_name?: string;
  account_name?: string;
}): Promise<DashboardDailyDetailResponse | null> {
  try {
    const entries = Object.entries(params).filter(([, v]) => v != null && v !== '') as [string, string][];
    const query = entries.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
    const url = CONST.apiUrl2 + 'dashboardDailyDetail' + (query ? `?${query}` : '');
    const response = await axios.get(url);
    const raw = response.data;
    if (raw == null) return null;
    const data =
      typeof raw.body === 'string'
        ? (JSON.parse(raw.body) as DashboardDailyDetailResponse)
        : raw.body != null
          ? (raw.body as DashboardDailyDetailResponse)
          : (raw as DashboardDailyDetailResponse);
    return data;
  } catch {
    return null;
  }
}

/** ダッシュボードKPI一括取得（accessDB2） */
export async function getDashboard(params?: { year?: number; month?: number; date?: string }): Promise<DashboardResponse | null> {
  try {
    let url = CONST.apiUrl2 + "dashboard";
    if (params) {
      const entries = Object.entries(params).filter(([, v]) => v != null) as [string, string | number][];
      if (entries.length > 0) {
        const query = entries.map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join("&");
        url += `?${query}`;
      }
    }
    const response = await axios.get(url);
    const raw = response.data;
    if (raw == null) return null;
    // Lambda proxy で body が文字列で返る場合
    const data =
      typeof raw.body === "string"
        ? (JSON.parse(raw.body) as DashboardResponse)
        : raw.body != null
          ? (raw.body as DashboardResponse)
          : (raw as DashboardResponse);
    if (data?.month_to_date == null || data?.last_month == null) return null;
    return data;
  } catch {
    return null;
  }
}
